import AvantiLogo from "./AvantiLogo";

export default AvantiLogo;
